import angular from 'angular';

module.exports = angular.module('common.filters.pluralize', [])
.filter('pluralize', function() {
  return function(count, singular, plural, showCount=true) {
    let noun;

    if (Math.abs(count) === 1) {
      noun = singular;
    } else {
      noun = plural;
    }

    if (showCount) {
      return count + ' ' + noun;
    } else {
      return noun;
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/pluralize.js
 **/